import React from 'react'
import useTranslation from '../hooks/useTranslation'

const Impressum = () => {
  const { t } = useTranslation();

  return (
    <div style={{ paddingTop: '120px' }}>
      <section>
        <div className="container">
          <h2>{t('legal.impressum')}</h2>
          
          <div style={{ marginBottom: '40px' }}>
            <h3>{t('legal.responsible')}</h3>
            <p>AYITE</p>
            <p>c/o Eltai Consulting</p>
            <p>Musterstraße 123</p>
            <p>20095 Hamburg</p>
            <p>Germany</p>
            <p>Email: contact@ayite-dj.com</p>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h3>{t('legal.vatId')}</h3>
            <p>DE123456789</p>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h3>{t('legal.disclaimer')}</h3>
            <h4>{t('legal.liability.content')}</h4>
            <p>{t('legal.liability.contentText')}</p>
            
            <h4>{t('legal.liability.links')}</h4>
            <p>{t('legal.liability.linksText')}</p>
            
            <h4>{t('legal.liability.copyright')}</h4>
            <p>{t('legal.liability.copyrightText')}</p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Impressum
